export const cookieSetOptions = {
  path: '/',
  expires: new Date(new Date().setFullYear(new Date().getFullYear() + 1)),
}
